import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { reloadForNewDeploy } from "./lib/stale-deploy";
import "./index.css";

// Vite fires this when a lazy chunk (or its CSS) fails to load — usually a tab older than the last deploy. The
// error still propagates (a route shows "A new version is available" while the reload happens).
window.addEventListener("vite:preloadError", () => {
  reloadForNewDeploy();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
